var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 23,
    viewBox: "0 0 14 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_265_178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.50005 13.6085V22.9142H8.57505V13.6085H12.3594L13.1469 9.32978H8.57505V7.81603C8.57505 5.55416 9.46317 4.68791 11.7557 4.68791C12.4688 4.68791 13.0419 4.70541 13.3744 4.74041V0.859785C12.7488 0.68916 11.2175 0.51416 10.3338 0.51416C5.65692 0.51416 3.50005 2.72353 3.50005 7.48791V9.32978H0.612549V13.6085H3.50005Z",
    fill: "#0A66B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_265_178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 22.4,
    fill: "white",
    transform: "translate(0 0.51416)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.e0fd635c8f7baee504d09044f0f61d8a.svg";
export { ForwardRef as ReactComponent };